module.exports = __webpack_public_path__ + "img/152_thumbnail.6762f7af.jpg";